import React from 'react';
import CustomTooltip from "../CustomTooltip";

import styles from './IconButton.module.css'

const IconButton = ({disabled, onClick, src, tooltip, label}) => {
  const button = <button
    className={styles.container}
    onClick={disabled ? undefined : onClick}
  >
    <img height="16" src={src}  alt="tooltip"/>
    {label && <span className="ms-2 text-black">{label}</span>}
  </button>;

  const component = tooltip ? <CustomTooltip label={tooltip}>
    {button}
  </CustomTooltip> : button;

  return (<>
    {component}
  </>);
};

export default IconButton;
